import * as React from "react";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
/**
 *
 * @param prefix
 * @param size
 */
var createGridColumnClass = function (prefix, size) {
    var defaultGridClassName = "scl-b-col-";
    if (!size) {
        return "";
    }
    if (typeof size === "number") {
        return "".concat(defaultGridClassName).concat(prefix).concat(size);
    }
    return Object.keys(size).reduce(function (value, bp) {
        var bpKey = bp;
        // eslint-disable-next-line
        var breakpoint = size[bpKey];
        return "".concat(value, " ").concat(defaultGridClassName).concat(bp, "-").concat(prefix).concat(breakpoint !== null && breakpoint !== void 0 ? breakpoint : "");
    }, "");
};
/**
 *
 * @param props
 */
var GridComp = function (props) {
    if (!props.children) {
        return null;
    }
    var sizeClassName = createGridColumnClass("", props.size);
    var offsetClassName = createGridColumnClass("offset-", props.offset);
    var className = joinClasses(props.className, sizeClassName, offsetClassName);
    return (React.createElement("div", { className: className }, props.children));
};
/**
 *
 */
export var Grid = asThemeConsumer(GridComp);
